// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * AgentHierarchyPanel ("Agents" tab) styles.
 * Reuses the IDE theme variables (--color-ide-*) so it tracks light/dark.
 * The message dialog reuses the global command-palette-* classes from ide.css.
 */

.agent-hierarchy-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--color-ide-surface);
  color: var(--color-ide-text);
}

.agent-hierarchy-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 12px;
  border-bottom: 1px solid var(--color-ide-border);
  user-select: none;
}

.agent-hierarchy-title {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: var(--color-ide-text-muted);
}

.agent-hierarchy-expand-all {
  flex: 0 0 auto;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid var(--color-ide-border);
  background: var(--color-ide-bg-secondary);
  color: var(--color-ide-text-secondary);
  cursor: pointer;
}

.agent-hierarchy-expand-all:hover {
  background: var(--color-ide-hover);
  color: var(--color-ide-text);
}

.agent-hierarchy-body {
  flex: 1;
  overflow: auto;
  padding: 4px 0;
}

.agent-hierarchy-empty {
  padding: 16px 12px;
  font-size: 12px;
  color: var(--color-ide-text-muted);
}

/* One agent node's compact row: [children chevron] [clickable header]. */
.agent-row {
  display: flex;
  align-items: center;
  gap: 2px;
  padding-right: 8px;
}

.agent-row-toggle,
.agent-row-toggle-spacer {
  flex: 0 0 auto;
  width: 16px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.agent-row-toggle {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--color-ide-text-muted);
}

.agent-row-toggle:hover {
  color: var(--color-ide-text);
}

/* Clickable header — toggles this node's info disclosure. */
.agent-row-header {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  text-align: left;
  color: var(--color-ide-text);
}

.agent-row-header:hover {
  background: var(--color-ide-surface-hover);
}

.agent-row-name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-info-caret {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  color: var(--color-ide-text-dim);
}

/* Expanded detail block for one node. */
.agent-row-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 8px;
  padding-top: 2px;
  padding-bottom: 8px;
}

.agent-row-desc {
  font-size: 11px;
  color: var(--color-ide-text-secondary);
  line-height: 1.35;
  word-break: break-word;
}

.agent-row-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 10px;
  color: var(--color-ide-text-dim);
}

.agent-row-scope {
  font-style: italic;
}

.agent-row-tool {
  font-size: 10px;
  color: var(--color-ide-text-dim);
}

.agent-row-tool-name {
  font-family: var(--font-mono, monospace);
  font-size: 10px;
  padding: 0 4px;
  border-radius: 3px;
  background: var(--color-ide-bg-secondary);
  color: var(--color-ide-text-secondary);
}

.agent-row-tool-none {
  font-style: italic;
}

/* Status pill. */
.agent-status {
  flex: 0 0 auto;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 1px 6px;
  border-radius: 8px;
  border: 1px solid currentColor;
  line-height: 1.5;
}

.agent-status-running {
  color: var(--color-ide-activity);
}

.agent-status-idle {
  color: var(--color-ide-text-muted);
}

/* Alive but only waiting out a deferred \`delay\` timer — dimmer than idle. */
.agent-status-sleeping {
  color: var(--color-ide-text-muted);
  opacity: 0.7;
}

.agent-status-done {
  color: #3fb950;
}

.agent-status-stopped {
  color: var(--color-ide-warn);
}

/* Transient state: stop requested, not yet honored (cooperative halt). */
.agent-status-stopping {
  color: var(--color-ide-warn);
  animation: agent-stopping-pulse 1s ease-in-out infinite;
}

@keyframes agent-stopping-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
}

.agent-row-actions {
  display: flex;
  gap: 6px;
  margin-top: 2px;
}

.agent-action-btn {
  font-size: 11px;
  padding: 2px 10px;
  border-radius: 4px;
  border: 1px solid var(--color-ide-border);
  background: var(--color-ide-bg-secondary);
  color: var(--color-ide-text);
  cursor: pointer;
}

.agent-action-btn:hover:not(:disabled) {
  background: var(--color-ide-hover);
}

.agent-action-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Message dialog: warning banner + multi-line input on top of the shared
   command-palette dialog chrome. */
.agent-message-warning {
  margin: 8px 0;
  padding: 8px 10px;
  font-size: 11px;
  line-height: 1.4;
  color: var(--color-ide-warn);
  background: var(--color-ide-error-bg);
  border: 1px solid var(--color-ide-warn);
  border-radius: 4px;
}

.agent-message-input {
  resize: vertical;
  min-height: 72px;
  font-family: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/AgentHierarchyPanel/agentHierarchyPanel.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,yCAAyC;EACzC,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,4EAA4E;AAC5E;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,yEAAyE;AACzE;EACE,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,yCAAyC;EACzC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;mCACmC;AACnC;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":["/*\n * AgentHierarchyPanel (\"Agents\" tab) styles.\n * Reuses the IDE theme variables (--color-ide-*) so it tracks light/dark.\n * The message dialog reuses the global command-palette-* classes from ide.css.\n */\n\n.agent-hierarchy-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--color-ide-surface);\n  color: var(--color-ide-text);\n}\n\n.agent-hierarchy-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 12px;\n  border-bottom: 1px solid var(--color-ide-border);\n  user-select: none;\n}\n\n.agent-hierarchy-title {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.15em;\n  color: var(--color-ide-text-muted);\n}\n\n.agent-hierarchy-expand-all {\n  flex: 0 0 auto;\n  font-size: 10px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: 1px solid var(--color-ide-border);\n  background: var(--color-ide-bg-secondary);\n  color: var(--color-ide-text-secondary);\n  cursor: pointer;\n}\n\n.agent-hierarchy-expand-all:hover {\n  background: var(--color-ide-hover);\n  color: var(--color-ide-text);\n}\n\n.agent-hierarchy-body {\n  flex: 1;\n  overflow: auto;\n  padding: 4px 0;\n}\n\n.agent-hierarchy-empty {\n  padding: 16px 12px;\n  font-size: 12px;\n  color: var(--color-ide-text-muted);\n}\n\n/* One agent node's compact row: [children chevron] [clickable header]. */\n.agent-row {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding-right: 8px;\n}\n\n.agent-row-toggle,\n.agent-row-toggle-spacer {\n  flex: 0 0 auto;\n  width: 16px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.agent-row-toggle {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: var(--color-ide-text-muted);\n}\n\n.agent-row-toggle:hover {\n  color: var(--color-ide-text);\n}\n\n/* Clickable header — toggles this node's info disclosure. */\n.agent-row-header {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 24px;\n  padding: 0 6px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  border-radius: 4px;\n  text-align: left;\n  color: var(--color-ide-text);\n}\n\n.agent-row-header:hover {\n  background: var(--color-ide-surface-hover);\n}\n\n.agent-row-name {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agent-info-caret {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  color: var(--color-ide-text-dim);\n}\n\n/* Expanded detail block for one node. */\n.agent-row-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-right: 8px;\n  padding-top: 2px;\n  padding-bottom: 8px;\n}\n\n.agent-row-desc {\n  font-size: 11px;\n  color: var(--color-ide-text-secondary);\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.agent-row-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 10px;\n  color: var(--color-ide-text-dim);\n}\n\n.agent-row-scope {\n  font-style: italic;\n}\n\n.agent-row-tool {\n  font-size: 10px;\n  color: var(--color-ide-text-dim);\n}\n\n.agent-row-tool-name {\n  font-family: var(--font-mono, monospace);\n  font-size: 10px;\n  padding: 0 4px;\n  border-radius: 3px;\n  background: var(--color-ide-bg-secondary);\n  color: var(--color-ide-text-secondary);\n}\n\n.agent-row-tool-none {\n  font-style: italic;\n}\n\n/* Status pill. */\n.agent-status {\n  flex: 0 0 auto;\n  font-size: 9px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 1px 6px;\n  border-radius: 8px;\n  border: 1px solid currentColor;\n  line-height: 1.5;\n}\n\n.agent-status-running {\n  color: var(--color-ide-activity);\n}\n\n.agent-status-idle {\n  color: var(--color-ide-text-muted);\n}\n\n/* Alive but only waiting out a deferred `delay` timer — dimmer than idle. */\n.agent-status-sleeping {\n  color: var(--color-ide-text-muted);\n  opacity: 0.7;\n}\n\n.agent-status-done {\n  color: #3fb950;\n}\n\n.agent-status-stopped {\n  color: var(--color-ide-warn);\n}\n\n/* Transient state: stop requested, not yet honored (cooperative halt). */\n.agent-status-stopping {\n  color: var(--color-ide-warn);\n  animation: agent-stopping-pulse 1s ease-in-out infinite;\n}\n\n@keyframes agent-stopping-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.45;\n  }\n}\n\n.agent-row-actions {\n  display: flex;\n  gap: 6px;\n  margin-top: 2px;\n}\n\n.agent-action-btn {\n  font-size: 11px;\n  padding: 2px 10px;\n  border-radius: 4px;\n  border: 1px solid var(--color-ide-border);\n  background: var(--color-ide-bg-secondary);\n  color: var(--color-ide-text);\n  cursor: pointer;\n}\n\n.agent-action-btn:hover:not(:disabled) {\n  background: var(--color-ide-hover);\n}\n\n.agent-action-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Message dialog: warning banner + multi-line input on top of the shared\n   command-palette dialog chrome. */\n.agent-message-warning {\n  margin: 8px 0;\n  padding: 8px 10px;\n  font-size: 11px;\n  line-height: 1.4;\n  color: var(--color-ide-warn);\n  background: var(--color-ide-error-bg);\n  border: 1px solid var(--color-ide-warn);\n  border-radius: 4px;\n}\n\n.agent-message-input {\n  resize: vertical;\n  min-height: 72px;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
